import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-left', 'CaretLeft', [["path",{"d":"M14 6l-6 6l6 6v-12"}]]);